/* eslint-disable no-undef */
import base64 from "base-64";
import utf8 from "utf8";
// Encoding UTF8 ⇢ base64
export const b64EncodeUnicode = (str: string = "") => {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16));
    }),
  );
};

// Decoding base64 ⇢ UTF8
export const b64DecodeUnicode = (str: string = "") => {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );
};

export const decodeBase64 = (value: string = "") => {
  let result: string = value;
  if (value.length) {
    const bytes = base64.decode(value);
    result = utf8.decode(bytes);
  }
  return result;
};

export const encodeBase64 = (value: string = "") => {
  let result: string = value;
  if (value.length) {
    const str = utf8.encode(value);
    result = base64.encode(str);
  }

  return result;
};
